import React from 'react'
import {
    Typography,
    Accordion as MuiAccordion,
    AccordionSummary as MuiAccordionSummary,
    AccordionDetails as MuiAccordionDetails,
    Collapse,
    styled,
} from '@mui/material'
import { ArrowIcon } from 'packages/eid-icons'

const StyledPanel = styled(MuiAccordion)(({ theme }) => ({
    width: '100%',
    border: 'none !important',
    '&:not(:last-child)': {
        borderBottom: '0px !important',
    },
    '&:before': {
        display: 'none',
    },
    '&.Mui-expanded': {
        margin: '0 !important',
    },
    '&.Mui-disabled': {
        backgroundColor: '#ffffff !important',
        pointerEvents: 'none',
        opacity: 0.66,
    },
}))

const StyledPanelSummary = styled(MuiAccordionSummary)(({ theme }) => ({
    minHeight: '0 !important',
    margin: '0 !important',
    borderBottom: '1px solid #e8e8ec !important',
    '&.Mui-expanded': {
        minHeight: '0 !important',
        marginTop: '0 !important',
        marginBottom: '0 !important',
        '& p': { fontWeight: 'bold !important' },
    },
    '& .MuiAccordionSummary-content': {},
}))

const StyledPanelDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    display: 'block',
    padding: 0,
    backgroundColor: '#fbfbfd',
}))

const Accordion = (props) => {
    const { expanded, children, title, disabled, ...rest } = props
    const [_expanded, setExpanded] = React.useState(expanded)

    return (
        <StyledPanel
            expanded={_expanded}
            onChange={() => setExpanded(!_expanded)}
            disabled={disabled}
            {...rest}
        >
            <StyledPanelSummary
                expandIcon={<ArrowIcon direction="down" color="#919193" />}
                disabled={disabled}
            >
                <Typography>{title}</Typography>
            </StyledPanelSummary>
            <Collapse in={_expanded} timeout={400} unmountOnExit>
                <StyledPanelDetails disabled={disabled}>
                    {children}
                </StyledPanelDetails>
            </Collapse>
        </StyledPanel>
    )
}

export default Accordion
